import { doc, getDoc, type Firestore } from "firebase/firestore";
import { isDistributor, isUser } from "../types";
import { LOCAL_STORAGE_KEYS } from "../constants";

export const getLoggedInuser = async (
  database: Firestore,
  userId: string,
): Promise<void> => {
  const userDocRef = doc(database, "users", userId);
  const userDocument = await getDoc(userDocRef);
  const user = userDocument.data();
  if (isUser(user)) {
    const distributorDocRef = doc(database, "distributors", user.distributor);
    const distributorDocument = await getDoc(distributorDocRef);
    const distributor = distributorDocument.data();
    if (isDistributor(distributor)) {
      window.localStorage.setItem(
        LOCAL_STORAGE_KEYS.USER_DISTRIBUTOR_ID,
        user.distributor,
      );
      window.localStorage.setItem(
        LOCAL_STORAGE_KEYS.USER_DISTRIBUTOR_NAME,
        distributor.name,
      );
      window.localStorage.setItem(LOCAL_STORAGE_KEYS.USER_NAME, user.name);
    } else {
      throw new Error("Distributor does not exist");
    }
  } else {
    throw new Error("User does not exist");
  }
};
